// ── 모바일 스타일 B: 카드 바디·상세행·결제 그룹·타임라인 ───────────────────────
// cardBody, 섹션 헤더/바디, 상세 행, 결제 목록, 서브탭, 날짜순 뷰 스타일

import { C, shadow } from './constants';

/** 카드 상세 바디 영역 */
export const cardBody = {
  borderTop: `1px solid ${C.borderLight}`,
  padding: '12px 16px 6px',
  background: 'var(--bg-subtle)',
};

/** 섹션 카드 (계약차감/택배비 등 각 소섹션) */
export const section = {
  marginBottom: 10,
  background: C.card,
  borderRadius: 10,
  border: `1px solid ${C.borderLight}`,
  overflow: 'hidden',
};
export const secHeader = {
  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
  padding: '7px 12px',
  background: 'var(--bg-subtle)',
  borderBottom: `1px solid ${C.borderLight}`,
};
export const secLabel = {
  fontSize: 10, fontWeight: 700, color: C.accent,
  textTransform: 'uppercase', letterSpacing: '0.06em',
};
export const secTotal  = { fontSize: 12, fontWeight: 700 };
export const secBody   = { padding: '4px 12px 6px' };

/** 상세 행: 2줄 구조 (라인1=날짜+이름+금액, 라인2=서브정보) */
export const dRow = {
  display: 'flex', flexDirection: 'column',
  gap: 3, padding: '7px 0',
  borderBottom: `1px solid ${C.borderLight}`,
  fontSize: 12,
};
/** 라인1: 날짜·레이블·금액/버튼 */
export const dLine = { display: 'flex', alignItems: 'center', gap: 6, minWidth: 0 };
/** 카드/전화/입금 라인1: 이름 — 자연스러운 너비, 넘치면 말줄임 */
export const payName = {
  color: C.main, fontWeight: 500, fontSize: 12,
  overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
  flexShrink: 1, minWidth: 0,
};
/** 레이블: flex:1 + 말줄임 */
export const dLabel = {
  flex: 1, minWidth: 0,
  color: C.main, fontWeight: 500, fontSize: 12,
  overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
};
/** 수량 표시 (상품명 옆 작은 텍스트) */
export const dQty  = { fontSize: 11, color: C.sub, fontWeight: 400 };
/** 라인2: 서비스품목 칩 */
export const dSub2 = { display: 'flex', alignItems: 'center', gap: 4, flexWrap: 'nowrap' };
/** 라인2: 송장번호 줄 */
export const dTrackRow = {
  display: 'flex', alignItems: 'center', gap: 4, overflow: 'hidden',
};
/** 송장번호+복사버튼 묶음 */
export const trackGroup = {
  display: 'inline-flex', alignItems: 'center', gap: 4,
  flex: 1, minWidth: 0, overflow: 'hidden',
};
/** 송장번호: 말줄임 */
export const trackNo = {
  fontSize: 11, color: C.subDark,
  overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
  minWidth: 0, fontVariantNumeric: 'tabular-nums',
};
/** 원금→수수료 줄 */
export const dAmtRow  = { display: 'flex', alignItems: 'center', gap: 5 };
/** 원금 금액 (작게) */
export const dOrigAmt = {
  fontSize: 11, color: C.sub,
  whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums', flexShrink: 0,
};
export const dArrow    = { fontSize: 10, color: C.border };
/** 전화승인 메모 등 소형 칩 */
export const payInfoChip = {
  fontSize: 10, color: C.subDark,
  background: C.bg, padding: '1px 5px', borderRadius: 4,
  border: `1px solid ${C.border}`,
  flexShrink: 0, whiteSpace: 'nowrap',
  maxWidth: 80, overflow: 'hidden', textOverflow: 'ellipsis',
};
export const dDate = { fontSize: 11, color: C.sub, flexShrink: 0, minWidth: 32 };
export const dName = {
  flex: 1, color: C.main, minWidth: 0, fontWeight: 500,
  overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
};
export const dSub  = { fontSize: 11, color: C.sub, flexShrink: 0, whiteSpace: 'nowrap' };
export const dAmt  = { fontWeight: 700, flexShrink: 0, fontSize: 12, whiteSpace: 'nowrap' };
export const courier = {
  fontSize: 10, color: C.sub, flexShrink: 0, background: C.bg,
  padding: '1px 5px', borderRadius: 4, whiteSpace: 'nowrap',
};
export const svcChip = {
  fontSize: 10, color: C.accent, background: C.accentBg,
  padding: '1px 5px', borderRadius: 4, flexShrink: 0,
};
export const taxChip = {
  marginLeft: 5, fontSize: 10, fontWeight: 700,
  background: '#dbeafe', color: '#1d4ed8',
  padding: '1px 5px', borderRadius: 4, flexShrink: 0,
};
export const unlinkChip = {
  marginLeft: 5, fontSize: 10, fontWeight: 700,
  background: C.minusBg, color: C.minus,
  padding: '1px 5px', borderRadius: 4, flexShrink: 0,
};
/** 연결 해제 버튼 (×) */
export const unlinkBtn = {
  background: 'none', border: `1px solid ${C.border}`,
  borderRadius: 4, padding: '3px',
  display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
  width: 20, height: 20,
  color: C.sub, cursor: 'pointer', flexShrink: 0,
};

/** 카드 푸터 — 3컬럼 구조 */
export const cardFooter = {
  display: 'flex', alignItems: 'center',
  padding: '10px 16px',
  borderTop: `1px solid ${C.borderLight}`,
  background: C.card,
};
export const footerItem = {
  flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center',
  gap: 2, minWidth: 0,
};
export const footerDivider = { width: 1, height: 26, background: C.borderLight, flexShrink: 0 };
export const footerLabel   = { fontSize: 9, color: C.sub };
export const footerVal     = {
  fontSize: 12, fontWeight: 700, whiteSpace: 'nowrap',
  fontVariantNumeric: 'tabular-nums',
};
export const footerNetVal  = {
  fontSize: 13, whiteSpace: 'nowrap',
  fontVariantNumeric: 'tabular-nums',
};

/** 미연결 결제 그룹 */
export const payGroup = { marginBottom: 18 };
export const payGroupHeader = {
  display: 'flex', alignItems: 'center', gap: 8,
  padding: '2px 2px 10px',
};
export const payGroupTitle = { fontSize: 13, fontWeight: 700, color: C.main };
export const payGroupCount = {
  fontSize: 11, fontWeight: 600, color: C.sub,
  background: C.bg, padding: '1px 7px', borderRadius: 10,
  border: `1px solid ${C.border}`,
};
export const payItem = {
  background: C.card, borderRadius: 12, marginBottom: 6,
  display: 'flex', alignItems: 'center',
  padding: '12px 14px', gap: 10,
  cursor: 'pointer', boxShadow: shadow.sm,
  border: `1.5px solid ${C.borderLight}`,
  transition: 'border-color 0.12s, box-shadow 0.12s, background 0.12s',
  userSelect: 'none',
};
export const payItemSel = {
  borderColor: C.accent, background: C.accentBg,
  boxShadow: `0 0 0 3px ${C.accentBdr}`,
};
export const paySelDot = {
  width: 10, height: 10, borderRadius: '50%',
  border: `2px solid`,
  flexShrink: 0,
  transition: 'background 0.12s, border-color 0.12s',
};
export const payContent = {
  flex: 1, minWidth: 0,
  display: 'flex', flexDirection: 'column', gap: 3,
};
export const payTopRow  = { display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 5 };
export const payDate    = { fontSize: 11, color: C.sub, flexShrink: 0 };
export const payLabel   = { fontSize: 13, fontWeight: 600, color: C.main };
export const paySub     = { fontSize: 11, color: C.sub };
export const payAmt     = { fontSize: 15, fontWeight: 700, color: C.main };
export const dragHandle = {
  color: C.sub, cursor: 'grab', flexShrink: 0,
  display: 'flex', alignItems: 'center', opacity: 0.5,
};

/** 날짜순 뷰 */
export const tlWrap = {
  padding: '8px 4px 32px',
  display: 'flex', flexDirection: 'column', gap: 4,
};
export const tlRow = {
  background: C.card, borderRadius: 10,
  padding: '9px 12px',
  display: 'flex', alignItems: 'center', gap: 7,
  boxShadow: shadow.sm,
  border: `1px solid ${C.borderLight}`,
  minWidth: 0,
};
export const tlDate = {
  fontSize: 11, color: C.sub, fontWeight: 600,
  flexShrink: 0, minWidth: 30,
};
export const tlBadge = {
  fontSize: 10, fontWeight: 700,
  padding: '2px 6px', borderRadius: 5,
  flexShrink: 0, whiteSpace: 'nowrap',
};
export const tlContent = {
  flex: 1, minWidth: 0,
  display: 'flex', flexDirection: 'column', gap: 1,
};
export const tlStore = {
  fontSize: 12, fontWeight: 700, color: C.main,
  overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
};
export const tlLabel = {
  fontSize: 11, color: C.subDark,
  overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
};
export const tlSub = {
  fontSize: 10, color: C.sub,
  overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
};
export const tlUnmatched = { fontSize: 11, fontWeight: 700, color: C.minus };
export const tlOrigAmt   = {
  fontSize: 10, color: C.sub,
  whiteSpace: 'nowrap', flexShrink: 0,
  fontVariantNumeric: 'tabular-nums',
};
export const tlAmt = {
  fontSize: 12, fontWeight: 700,
  whiteSpace: 'nowrap', flexShrink: 0,
  fontVariantNumeric: 'tabular-nums',
  display: 'flex', alignItems: 'center', gap: 3,
};
export const tlRawTag = {
  fontSize: 9, fontWeight: 600,
  background: C.warnBg, color: C.warn,
  padding: '1px 4px', borderRadius: 3,
};
